














import { defineComponent } from '~/utils/nuxt3-migration'
import { ciAngleRight } from '~/icons/source/light/angle-right'

export default defineComponent({
  props: {
    suggestion: { type: Object, required: true },
    inGenericSearch: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup() {
    return {
      ciAngleRight
    }
  }
})
